import config from './config';
import Log from './utils/Log';
import ConsoleLogger from './utils/loggers/ConsoleLogger';

/** @ignore */
const TAG = 'LogBootstrap';

// Setup library-level logging
const log = new Log;

log.setLogPrefix(config.logPrefix);

/** @ignore */
const logger = new ConsoleLogger;
if (!config.debug) {
    logger.setLogLevel(log.WARN);
}
log.addLogger(logger);
log.send(log.DEBUG, TAG, 'Initialized logging.');


/** @type {src/utils/Log.js~Log} */
export default log;



// WEBPACK FOOTER //
// ./src/log.js